import React, { Fragment } from 'react';

const StreamSecondaryLogo = () => {
  return (
    <Fragment>
      <div className="secondary-logo-container-stream">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1329.3467 256.38666"
          id="svg2"
          version="1.1"
        >
          <defs id="defs6" />
          <g transform="matrix(1.3333333,0,0,-1.3333333,0,256.38667)" id="g10">
            <g transform="scale(0.1)" id="g12">
              <path
                id="path14"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="M 44.3867,312.781 H 280.488 v -61.5 H 112.605 V 185.82 h 147.954 v -61.5 H 112.605 V 5.26953 H 44.3867 V 312.781"
              />
              <path
                id="path16"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 364.641,312.781 h 68.211 V 5.26953 H 364.641 V 312.781"
              />
              <path
                id="path18"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 536.941,312.781 h 62.903 L 745.137,123.449 v 189.332 h 67.336 V 5.26953 H 754.441 L 604.277,200.762 V 5.26953 H 536.941 V 312.781"
              />
              <path
                id="path20"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 1034.38,66.3398 c 55.83,0 93.47,37.3322 93.47,91.8012 v 0.879 c 0,54.468 -37.64,92.699 -93.47,92.699 h -52.7 V 66.3398 Z M 913.457,312.781 h 120.923 c 97.46,0 164.79,-66.34 164.79,-152.883 V 159.02 C 1199.17,72.4805 1131.84,5.26953 1034.38,5.26953 H 913.457 V 312.781"
              />
              <path
                id="path22"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 1689.52,158.141 v 0.879 c 0,52.718 -38.98,96.652 -93.91,96.652 -54.93,0 -93.02,-43.051 -93.02,-95.774 v -0.878 c 0,-52.711 38.98,-96.6411 93.9,-96.6411 54.94,0 93.03,43.0511 93.03,95.7621 z m -258.25,0 v 0.879 c 0,87.421 69.54,159.031 165.22,159.031 95.69,0 164.34,-70.731 164.34,-158.153 V 159.02 C 1760.83,71.6016 1691.29,0 1595.61,0 1499.93,0 1431.27,70.7188 1431.27,158.141"
              />
              <path
                id="path24"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 1844.09,137.059 v 175.722 h 68.22 V 138.82 c 0,-50.0817 25.25,-75.9997 66.89,-75.9997 41.64,0 66.88,25.0391 66.88,73.8007 v 176.16 h 68.22 V 139.262 c 0,-93.1409 -52.71,-138.820594 -135.99,-138.820594 -83.27,0 -134.22,46.117194 -134.22,136.617594"
              />
              <path
                id="path26"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 2284.39,250.398 h -94.35 v 62.383 h 256.92 v -62.383 h -94.35 V 5.26953 h -68.22 V 250.398"
              />
              <path
                id="path28"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 2686.14,312.781 h 68.23 V 191.09 h 125.8 v 121.691 h 68.21 V 5.26953 h -68.21 V 128.711 h -125.8 V 5.26953 h -68.23 V 312.781"
              />
              <path
                id="path30"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 3293.89,158.141 v 0.879 c 0,52.718 -38.99,96.652 -93.92,96.652 -54.92,0 -93.02,-43.051 -93.02,-95.774 v -0.878 c 0,-52.711 38.99,-96.6411 93.91,-96.6411 54.93,0 93.03,43.0511 93.03,95.7621 z m -258.26,0 v 0.879 c 0,87.421 69.55,159.031 165.23,159.031 95.68,0 164.34,-70.731 164.34,-158.153 V 159.02 C 3365.2,71.6016 3295.65,0 3199.97,0 3104.3,0 3035.63,70.7188 3035.63,158.141"
              />
              <path
                id="path32"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 3429.42,312.781 h 73.09 l 64.23,-208.23 69.55,209.109 h 58.47 l 69.54,-209.109 64.24,208.23 h 71.3 L 3793.98,3.07031 h -59.36 L 3664.64,204.281 3594.65,3.07031 h -59.36 L 3429.42,312.781"
              />
              <path
                id="path34"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 4141.24,312.781 h 68.21 V 5.26953 h -68.21 V 312.781"
              />
              <path
                id="path36"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 4313.54,312.781 h 62.91 l 145.29,-189.332 v 189.332 h 67.33 V 5.26953 h -58.03 L 4380.88,200.762 V 5.26953 h -67.34 V 312.781"
              />
              <path
                id="path38"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 4690.06,312.781 h 62.9 l 145.29,-189.332 v 189.332 h 67.34 V 5.26953 h -58.03 L 4757.39,200.762 V 5.26953 h -67.33 V 312.781"
              />
              <path
                id="path40"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 5311.08,158.141 v 0.879 c 0,52.718 -38.98,96.652 -93.91,96.652 -54.92,0 -93.02,-43.051 -93.02,-95.774 v -0.878 c 0,-52.711 38.98,-96.6411 93.91,-96.6411 54.93,0 93.02,43.0511 93.02,95.7621 z m -258.25,0 v 0.879 c 0,87.421 69.54,159.031 165.23,159.031 95.68,0 164.33,-70.731 164.33,-158.153 V 159.02 C 5382.39,71.6016 5312.85,0 5217.17,0 5121.49,0 5052.83,70.7188 5052.83,158.141"
              />
              <path
                id="path42"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 5443.96,312.781 h 75.31 l 81.05,-216.5701 81.07,216.5701 h 73.53 L 5629.56,3.07031 h -60.24 L 5443.96,312.781"
              />
              <path
                id="path44"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 6007.85,133.98 -41.2,99.731 -41.19,-99.731 z m -71.77,181 h 62.9 L 6131.88,5.26953 h -71.32 L 6032.21,74.2383 H 5901.09 L 5872.74,5.26953 H 5803.2 L 5936.08,314.98"
              />
              <path
                id="path46"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 6278.94,250.398 h -94.36 v 62.383 h 256.92 v -62.383 h -94.35 V 5.26953 h -68.21 V 250.398"
              />
              <path
                id="path48"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 6523,312.781 h 68.21 V 5.26953 H 6523 V 312.781"
              />
              <path
                id="path50"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 6668.73,312.781 h 75.3 l 81.06,-216.5701 81.06,216.5701 h 73.54 L 6854.33,3.07031 h -60.25 L 6668.73,312.781"
              />
              <path
                id="path52"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 7054.54,312.781 h 233.89 v -60.179 h -166.12 v -62.391 h 146.19 v -60.18 H 7122.31 V 65.4609 h 168.33 V 5.26953 h -236.1 V 312.781"
              />
              <path
                id="path54"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 7623.73,126.512 -119.16,186.269 h 79.74 l 73.97,-123.453 75.3,123.453 h 77.52 L 7691.94,127.832 V 5.26953 h -68.21 V 126.512"
              />
              <path
                id="path56"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 8126.48,158.141 v 0.879 c 0,52.718 -38.98,96.652 -93.91,96.652 -54.92,0 -93.02,-43.051 -93.02,-95.774 v -0.878 c 0,-52.711 38.99,-96.6411 93.91,-96.6411 54.93,0 93.02,43.0511 93.02,95.7621 z m -258.25,0 v 0.879 c 0,87.421 69.54,159.031 165.23,159.031 95.68,0 164.33,-70.731 164.33,-158.153 V 159.02 C 8197.79,71.6016 8128.25,0 8032.57,0 7936.89,0 7868.23,70.7188 7868.23,158.141"
              />
              <path
                id="path58"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 8280.18,137.059 v 175.722 h 68.22 V 138.82 c 0,-50.0817 25.24,-75.9997 66.88,-75.9997 41.64,0 66.89,25.0391 66.89,73.8007 v 176.16 h 68.21 V 139.262 c 0,-93.1409 -52.7,-138.820594 -135.99,-138.820594 -83.27,0 -134.21,46.117194 -134.21,136.617594"
              />
              <path
                id="path60"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 8982.27,133.98 -41.21,99.731 -41.19,-99.731 z m -71.77,181 h 62.9 L 9106.29,5.26953 h -71.32 L 9006.62,74.2383 H 8875.51 L 8847.16,5.26953 h -69.54 L 8910.5,314.98"
              />
              <path
                id="path62"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 9318.47,163.422 c 33.22,0 52.26,17.566 52.26,43.488 v 0.879 c 0,29 -20.38,43.93 -53.59,43.93 h -67.77 v -88.297 z m -137.33,149.359 h 141.75 c 39.42,0 69.99,-10.992 90.36,-31.191 17.29,-17.129 26.58,-41.301 26.58,-70.289 v -0.879 c 0,-49.641 -27.02,-80.832 -66.44,-95.32 L 9449.14,5.26953 h -79.74 l -66.44,98.40247 h -0.89 -52.7 V 5.26953 h -68.23 V 312.781"
              />
              <path
                id="path64"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 9528.42,312.781 h 233.88 v -60.179 h -166.11 v -62.391 h 146.18 v -60.18 H 9596.19 V 65.4609 h 168.33 V 5.26953 h -236.1 V 312.781"
              />
              <path
                id="path66"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 9850.44,75.5508 h 71.76 V 5.26953 h -71.76 z m -3.55,228.4372 v 8.793 h 78.85 v -8.793 L 9904.92,109.82 h -37.21 l -20.82,194.168"
              />
              <path
                id="path68"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="M 28.5,1913.44 H 150.605 V 1363.05 H 28.5 v 550.39"
              />
              <path
                id="path70"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="M 291,1913.44 H 403.605 L 663.68,1574.56 v 338.88 H 784.211 V 1363.05 H 680.34 l -268.805,349.9 v -349.9 H 291 v 550.39"
              />
              <path
                id="path72"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 915.93,1913.44 h 112.61 l 260.07,-338.88 v 338.88 h 120.53 v -550.39 h -103.87 l -268.81,349.9 v -349.9 H 915.93 v 550.39"
              />
              <path
                id="path74"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 1978.54,1636.68 v 1.58 c 0,94.34 -69.75,172.96 -168.1,172.96 -98.32,0 -166.51,-77.04 -166.51,-171.39 v -1.57 c 0,-94.37 69.79,-172.99 168.11,-172.99 98.32,0 166.5,77.04 166.5,171.41 z m -462.27,0 v 1.58 c 0,156.46 124.49,284.63 295.77,284.63 171.28,0 294.19,-126.59 294.19,-283.06 v -1.57 c 0,-156.5 -124.51,-284.64 -295.79,-284.64 -171.26,0 -294.17,126.59 -294.17,283.06"
              />
              <path
                id="path76"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 2168.94,1913.44 h 134.82 l 145.09,-387.63 145.12,387.63 h 131.64 L 2501.2,1359.12 h -107.85 l -224.41,554.32"
              />
              <path
                id="path78"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 3131.68,1593.43 -73.73,178.49 -73.76,-178.49 z m -128.46,323.93 h 112.61 l 237.89,-554.31 h -127.67 l -50.74,123.44 h -234.72 l -50.75,-123.44 h -124.51 l 237.89,554.31"
              />
              <path
                id="path80"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 3568.67,1801.8 h -168.9 v 111.64 h 459.92 V 1801.8 h -168.91 v -438.75 h -122.11 v 438.75"
              />
              <path
                id="path82"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 4384.69,1636.68 v 1.58 c 0,94.34 -69.78,172.96 -168.1,172.96 -98.32,0 -166.53,-77.04 -166.53,-171.39 v -1.57 c 0,-94.37 69.78,-172.99 168.1,-172.99 98.33,0 166.53,77.04 166.53,171.41 z m -462.29,0 v 1.58 c 0,156.46 124.48,284.63 295.76,284.63 171.29,0 294.2,-126.59 294.2,-283.06 v -1.57 c 0,-156.5 -124.49,-284.64 -295.77,-284.64 -171.28,0 -294.19,126.59 -294.19,283.06"
              />
              <path
                id="path84"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 4868.48,1646.11 c 59.48,0 93.57,31.44 93.57,77.84 v 1.57 c 0,51.9 -36.49,78.62 -95.94,78.62 h -121.34 v -158.03 z m -245.82,267.33 h 253.75 c 70.56,0 125.29,-19.65 161.75,-55.82 30.94,-30.67 47.57,-73.92 47.57,-125.8 v -1.57 c 0,-88.87 -48.34,-144.69 -118.93,-170.64 l 135.59,-196.56 h -142.71 l -118.96,176.14 h -1.58 -94.37 v -176.14 h -122.11 v 550.39"
              />
              <path
                id="path86"
                style={{
                  fill: '#1aff1a',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 5159.55,1443.24 72.16,85.72 c 49.95,-40.9 102.3,-66.85 165.73,-66.85 49.97,0 80.09,19.65 80.09,51.9 v 1.58 c 0,30.67 -19.04,46.39 -111.81,69.97 -111.8,28.32 -183.96,58.97 -183.96,168.26 v 1.58 c 0,99.87 80.86,165.92 194.27,165.92 80.89,0 149.87,-25.18 206.17,-70 l -63.43,-91.19 c -49.17,33.79 -97.55,54.24 -144.32,54.24 -46.79,0 -71.36,-21.22 -71.36,-47.97 v -1.55 c 0,-36.17 23.79,-47.97 119.74,-72.35 112.6,-29.1 176.03,-69.2 176.03,-165.11 v -1.58 c 0,-109.29 -84.07,-170.64 -203.8,-170.64 -84.04,0 -168.9,29.1 -235.51,88.07"
              />
              <path
                id="path88"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 5939.13,1913.44 h 131.64 l 145.89,-232.74 145.92,232.74 h 131.62 v -550.39 h -121.31 v 359.33 l -156.23,-235.09 h -3.17 l -154.63,232.74 v -356.98 h -119.73 v 550.39"
              />
              <path
                id="path90"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 6625.91,1913.44 h 418.68 v -107.72 h -297.34 v -111.64 h 261.67 v -107.72 h -261.67 v -115.59 h 301.32 v -107.72 h -422.66 v 550.39"
              />
              <path
                id="path92"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 7152.5,1913.44 h 112.6 l 260.1,-338.88 v 338.88 h 120.51 v -550.39 h -103.88 l -268.8,349.9 v -349.9 H 7152.5 v 550.39"
              />
              <path
                id="path94"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 7909.87,1801.8 h -168.91 v 111.64 h 459.92 V 1801.8 h -168.91 v -438.75 h -122.1 v 438.75"
              />
              <path
                id="path96"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 8730.61,1636.68 v 1.58 c 0,94.34 -69.78,172.96 -168.1,172.96 -98.33,0 -166.53,-77.04 -166.53,-171.39 v -1.57 c 0,-94.37 69.78,-172.99 168.13,-172.99 98.32,0 166.5,77.04 166.5,171.41 z m -462.3,0 v 1.58 c 0,156.46 124.52,284.63 295.8,284.63 171.25,0 294.16,-126.59 294.16,-283.06 v -1.57 c 0,-156.5 -124.48,-284.64 -295.76,-284.64 -171.29,0 -294.2,126.59 -294.2,283.06"
              />
              <path
                id="path98"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 9211.25,1646.11 c 59.48,0 93.57,31.44 93.57,77.84 v 1.57 c 0,51.9 -36.47,78.62 -95.95,78.62 h -121.33 v -158.03 z m -245.82,267.33 h 253.75 c 70.58,0 125.28,-19.65 161.78,-55.82 30.91,-30.67 47.57,-73.92 47.57,-125.8 v -1.57 c 0,-88.87 -48.37,-144.69 -118.96,-170.64 l 135.59,-196.56 h -142.72 l -118.95,176.14 h -1.58 -94.37 v -176.14 h -122.11 v 550.39"
              />
              <path
                id="path100"
                style={{
                  fill: '#f20000',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 9502.32,1443.24 72.16,85.72 c 49.97,-40.9 102.3,-66.85 165.73,-66.85 49.97,0 80.08,19.65 80.08,51.9 v 1.58 c 0,30.67 -19.03,46.39 -111.8,69.97 -111.8,28.32 -183.96,58.97 -183.96,168.26 v 1.58 c 0,99.87 80.89,165.92 194.27,165.92 80.89,0 149.87,-25.18 206.17,-70 l -63.43,-91.19 c -49.17,33.79 -97.55,54.24 -144.32,54.24 -46.8,0 -71.36,-21.22 -71.36,-47.97 v -1.55 c 0,-36.17 23.79,-47.97 119.73,-72.35 112.61,-29.1 176.04,-69.2 176.04,-165.11 v -1.58 c 0,-109.29 -84.07,-170.64 -203.8,-170.64 -84.04,0 -168.91,29.1 -235.51,88.07"
              />
              <path
                id="path102"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="M 511.816,781.031 408.797,1030.42 305.777,781.031 Z M 332.367,1233.68 H 489.66 L 822.027,459.102 H 643.672 L 572.766,631.609 H 244.828 L 173.926,459.102 H 0 l 332.367,774.578"
              />
              <path
                id="path104"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 935.168,1228.19 h 157.322 l 363.38,-473.542 v 473.542 h 168.4 V 459.102 H 1479.13 L 1103.56,948.035 V 459.102 H 935.168 v 769.088"
              />
              <path
                id="path106"
                style={{
                  fill: '#fff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 2115.19,611.828 c 139.62,0 233.78,93.383 233.78,229.613 v 2.207 c 0,136.239 -94.16,231.832 -233.78,231.832 H 1983.36 V 611.828 Z m -302.44,616.362 h 302.44 c 243.73,0 412.13,-165.89 412.13,-382.35 v -2.192 c 0,-216.449 -168.4,-384.546 -412.13,-384.546 h -302.44 v 769.088"
              />
              <path
                id="path108"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 3010.55,1228.19 h 584.97 V 1077.67 H 3180.04 V 921.66 h 365.63 V 771.121 H 3180.04 V 609.609 h 421 V 459.102 h -590.49 v 769.088"
              />
              <path
                id="path110"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 3752.94,1228.19 h 183.91 l 203.85,-325.221 203.86,325.221 h 183.91 V 459.102 H 4358.95 V 961.195 L 4140.7,632.699 h -4.43 L 3920.22,957.914 V 459.102 h -167.28 v 769.088"
              />
              <path
                id="path112"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 5008.3,840.34 c 85.32,0 135.19,50.539 135.19,116.48 v 2.188 c 0,75.812 -53.18,116.472 -138.5,116.472 H 4873.17 V 840.34 Z m -305.77,387.85 h 316.88 c 185,0 296.91,-108.76 296.91,-265.87 v -2.218 c 0,-177.981 -139.62,-270.274 -313.54,-270.274 H 4873.17 V 459.102 h -170.64 v 769.088"
              />
              <path
                id="path114"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 5444.94,1228.19 h 170.62 V 612.922 h 386.64 v -153.82 h -557.26 v 769.088"
              />
              <path
                id="path116"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 6740.16,841.441 v 2.207 c 0,131.832 -97.49,241.712 -234.87,241.712 -137.38,0 -232.66,-107.665 -232.66,-239.52 v -2.192 c 0,-131.847 97.5,-241.726 234.87,-241.726 137.38,0 232.66,107.687 232.66,239.519 z m -645.91,0 v 2.207 c 0,218.652 173.95,397.732 413.25,397.732 239.31,0 411.02,-176.9 411.02,-395.54 v -2.192 c 0,-218.636 -173.93,-397.738 -413.23,-397.738 -239.31,0 -411.04,176.891 -411.04,395.531"
              />
              <path
                id="path118"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 7290.93,762.34 -298.04,465.85 h 199.42 l 185.01,-308.749 188.37,308.749 h 193.86 L 7461.52,765.648 V 459.102 H 7290.93 V 762.34"
              />
              <path
                id="path120"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 7863.8,1228.19 h 584.97 V 1077.67 H 8033.3 V 921.66 h 365.63 V 771.121 H 8033.3 V 609.609 h 420.99 V 459.102 H 7863.8 v 769.088"
              />
              <path
                id="path122"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 8949.64,854.629 c 83.11,0 130.73,43.973 130.73,108.785 v 2.188 c 0,72.508 -50.96,109.878 -134.07,109.878 H 8776.81 V 854.629 Z m -343.45,373.561 h 354.53 c 98.61,0 175.05,-27.48 226.01,-78.01 43.19,-42.85 66.47,-103.26 66.47,-175.793 v -2.192 c 0,-124.164 -67.59,-202.164 -166.18,-238.425 l 189.46,-274.668 h -199.42 l -166.21,246.109 h -2.19 -131.85 V 459.102 h -170.62 v 769.088"
              />
              <path
                id="path124"
                style={{
                  fill: '#0000ff',
                  fillOpacity: '1',
                  fillRule: 'nonzero',
                  stroke: 'none'
                }}
                d="m 9356.36,571.172 100.8,119.758 c 69.81,-57.129 142.93,-93.391 231.56,-93.391 69.79,0 111.91,27.473 111.91,72.512 v 2.187 c 0,42.852 -26.59,64.84 -156.22,97.793 -156.23,39.559 -257.03,82.41 -257.03,235.139 v 2.19 c 0,139.53 113,231.82 271.44,231.82 112.98,0 209.38,-35.15 288.05,-97.79 l -88.63,-127.44 c -68.71,47.25 -136.28,75.82 -201.66,75.82 -65.35,0 -99.68,-29.69 -99.68,-67.04 v -2.19 c 0,-50.532 33.21,-67.032 167.28,-101.099 157.32,-40.632 245.95,-96.66 245.95,-230.703 v -2.218 c 0,-152.7 -117.44,-238.418 -284.72,-238.418 -117.46,0 -235.99,40.66 -329.05,123.07"
              />
            </g>
          </g>
        </svg>
      </div>
    </Fragment>
  );
};

export default StreamSecondaryLogo;
